import { Text } from '@dixa/lib-shared-habla';

import { ConversationAutomationAuditLogEntry } from 'apis/auditLogs';

type RoutedThroughReplyProps = {
  node: ConversationAutomationAuditLogEntry<'AUTOMATION_REPLY_NODE_VISITED'>;
};

export function RoutedThroughReply({
  node,
}: RoutedThroughReplyProps): JSX.Element {
  if (node.error) {
    return (
      <Text.Paragraph>Reply · Failed with error: {node.error}</Text.Paragraph>
    );
  }

  return (
    <Text.Paragraph>Reply · Automation visited reply action</Text.Paragraph>
  );
}
